<script setup lang="ts">
import FormServico from '../components/form-servico.vue'
import { useServicoStore } from '../store/useServicoStore'

definePage({
  meta: {
    navActiveLink: 'admin-servico',
    action: 'edit',
    subject: 'servico',
  },
})

const store = useServicoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormServico is-editing />
</template>
